import CheckOutlined from '@mui/icons-material/CheckOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import { MobileOpCode } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import StatusChip from 'v2/components/StatusChip/StatusChip';

interface Props {
  action: MobileOpCode;
  iconOnly: boolean;
}

const AccessEventStatusChip: React.FC<Props> = ({ action, iconOnly }) => {
  const { translation } = useTranslation();
  switch (action) {
    case MobileOpCode.AccessGranted:
      return <StatusChip color="success" icon={CheckOutlined} label={translation.access_granted} iconOnly={iconOnly} />;
    case MobileOpCode.ResultPending:
      return (
        <StatusChip color="warning" icon={HourglassEmpty} label={translation.unverified_event} iconOnly={iconOnly} />
      );
    default:
      return <StatusChip color="error" icon={CloseOutlined} label={translation.access_denied} iconOnly={iconOnly} />;
  }
};

export default AccessEventStatusChip;
